// Copyright (c) 2017 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import {
    injectIntl,
    intlShape
} from 'react-intl';
import Facets from '../../state/facets';
import LaborAdditiveFacets from './labor-additive-facets';
import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import LaborAdditiveSummaryList from '../labor-additive-summary/labor-additive-summary-list';
import LaborAdditiveSummaryModal from '../labor-additive-summary/labor-additive-summary-modal';
import {buildLaborAdditiveSummariesObject} from '../../../shared/services/build-labor-additive-summaries-object';

function handleModalClose() {

    this.actions.updateLaborAdditiveSummaryModalVisibility(false);

}

function handleModalOpen(laborAdditiveSummary) {

    this.actions.updateLaborAdditiveSummary(laborAdditiveSummary);
    this.actions.updateLaborAdditiveSummaryModalVisibility(true);

}

function handleShowHideMoreGroups(areVisible) {

    this.actions.updateShowMoreGroupsVisibility(areVisible);

}

class LaborAdditivePipsAside extends Component {

    componentWillMount() {

        this.props.actions.readLaborAdditiveSummaries();

    }

    componentWillUnmount() {

        this.props.actions.updateLaborAdditiveSummaryModalVisibility(false);

    }

    render() {

        const laborAdditiveSummariesObject = buildLaborAdditiveSummariesObject(this.props.laborAdditiveSummaries);

        return (
            <aside className='aside-container'>
                <LaborAdditiveSummaryList
                    count={this.props.laborAdditiveSummaries.length}
                    isMoreSummaryVisible={this.props.isMoreSummaryVisible}
                    laborAdditiveSummariesObject={laborAdditiveSummariesObject}
                    onModalOpen={this.props::handleModalOpen}
                    showHideMoreGroups={this.props::handleShowHideMoreGroups}
                />
                <LaborAdditiveFacets
                    actions={this.props.actions}
                    facets={this.props.facets}
                />
                <LaborAdditiveSummaryModal
                    isVisible={this.props.isVisible}
                    laborAdditiveSummary={this.props.laborAdditiveSummary}
                    onModalClose={this.props::handleModalClose}
                />
            </aside>

        );

    }
}

LaborAdditivePipsAside.displayName = 'LaborAdditivePipsAside';
LaborAdditivePipsAside.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets),
    intl: intlShape.isRequired,
    isMoreSummaryVisible: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    laborAdditiveSummaries: PropTypes.arrayOf(PropTypes.instanceOf(LaborAdditiveSummary)).isRequired,
    laborAdditiveSummary: PropTypes.instanceOf(LaborAdditiveSummary).isRequired
};

export default injectIntl(LaborAdditivePipsAside);



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-pips-aside/labor-additive-pips-aside.js